import API, { baseURL } from './api';
import { getSucursalInfo } from './auth';

// Client for sge_infantil_core's routes/evaluation.js (mounted at /api/evaluation).
// Uses POST /trimester exclusively — it's the richer endpoint (tracks period/year/
// evaluationType, weight-sum guard scoped per subject+period+year) vs the plain
// POST / (weight guard scoped only per subject, no period/year).
export async function createTrimesterEvaluation(payload) {
  const sucursalId = getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/evaluation/trimester`, { sucursalId, ...payload });
}

export async function listEvaluations(levelId, subjectId) {
  return API.get(`${baseURL}api/evaluation/${levelId}`, { params: { subjectId } });
}

export async function deleteEvaluation(id) {
  return API.delete(`${baseURL}api/evaluation/${id}`);
}
